// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBEb7f7lxKZx6Eb13D4DT1Vk2Y5zCSjIDU",
  authDomain: "empower-lenders-b0a63.firebaseapp.com",
  projectId: "empower-lenders-b0a63",
  storageBucket: "empower-lenders-b0a63.appspot.com",
  messagingSenderId: "642257620958",
  appId: "1:642257620958:web:39087693bc8c89ff47574f",
  measurementId: "G-5230EGM6VZ"
};

// Initialize Firebase
export const firebase = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebase);